var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#E5E5E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6466 18.9527C21.1153 19.4214 21.1153 20.1807 20.6466 20.6494C20.4141 20.8838 20.1066 21 19.7992 21C19.4917 21 19.185 20.8828 18.951 20.6485L14.9995 16.6991L11.0485 20.6475C10.8141 20.8838 10.507 21 10.1999 21C9.89281 21 9.58608 20.8838 9.35154 20.6475C8.88282 20.1788 8.88282 19.4195 9.35154 18.9508L13.3037 14.9986L9.35154 11.0483C8.88282 10.5796 8.88282 9.82025 9.35154 9.35154C9.82025 8.88282 10.5796 8.88282 11.0483 9.35154L14.9995 13.3056L18.9517 9.35341C19.4204 8.8847 20.1798 8.8847 20.6485 9.35341C21.1172 9.82212 21.1172 10.5814 20.6485 11.0502L16.6963 15.0023L20.6466 18.9527Z",
    fill: "#F70F21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/Cross.a6582981af81d9d36087b1921fd73953.svg";
export { ForwardRef as ReactComponent };